import Layout from '@/pages/frame';
import beddingStatistics from '@/pages/beddingStatistics/beddingStatistics.vue';
export default {
	path: '/gqtj',
	menuName: '归寝统计',
	component: Layout,
	children: [{
		path: 'index',
		menuName: '归寝',
		
		// component: require('@/pages/home/index'),
		component: beddingStatistics,
	}],
	
}


// WEBPACK FOOTER //
// ./src/routes/modules/beddingStatistics.js